
import useUserApi from "src/lib/filmwebid/useUserApi";
import { useEffect, useState, useCallback } from "react";

export default function useReviewReport(reviewerUserId: string, reviewId: number): [doReport: () => void, isReporting: boolean, isReportingDone: boolean] {
	const updater = useUserApi();
	const [isReporting, setIsReporting] = useState(false);
	const [isReportingDone, setIsReportingDone] = useState(false);
	const [payload, setPayload] = useState<{ reviewId: number, reviewerUserId: string } | null>(null);

	useEffect(() => {
		if (payload !== null) {
			const _action = async () => {
				await updater("/api/Reviews/Report", { method: "POST", allowAnon: false, body: { reviewId: payload.reviewId } })
				setIsReporting(false);
				setIsReportingDone(true);
			};
			setIsReporting(true);
			setIsReportingDone(false);
			_action();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [payload]);


	const doReport = useCallback(() => {
		setPayload({ reviewId, reviewerUserId });
	}, [reviewId, reviewerUserId]);

	return [doReport, isReporting, isReportingDone]
}